import React from "react";
import { Router, Switch } from "react-router-dom";

import Login from "./containers/pages/Login";
import ForgotPassword from "./containers/pages/ForgotPassword";
import ResetPassword from "./containers/pages/ResetPassword";
import Home from "./containers/pages/Home";
import Users from "./containers/pages/Users";
import Networks from "./containers/pages/Networks";
import Restaurants from "./containers/pages/Restaurants";
import Connections from "./containers/pages/Connections";
import Settings from "./containers/pages/Settings";
//import Przelewy24 from "./containers/pages/przelewy24/Przelewy24";
import P24Transactions from "./containers/pages/przelewy24/P24Transactions";
import P24Transaction from "./containers/pages/przelewy24/P24Transaction";
import P24Merchants from "./containers/pages/przelewy24/P24Merchants";
import P24Logs from "./containers/pages/przelewy24/P24Logs";
import NotFoundPage from "./containers/pages/NotFoundPage";

//import MainContent from "./containers/layout/MainContent"
import P24MainContent from "./containers/layout/P24MainContent"

import ParentLayout from "./containers/layout/ParentLayout"
import PublicLayout from "./containers/layout/PublicLayout"
import PrivateLayout from "./containers/layout/PrivateLayout";

import { routes } from "./constants/routes";

import { history } from "./helpers/history";

import PrivateRoute from "./components/PrivateRoute";
import { PublicRoute } from "./components/PublicRoute";

import './App.css';
import RestaurantP24Transactions from "./containers/pages/restaurants/RestaurantP24Transactions";
import Restaurant from "./containers/pages/restaurants/Restaurant";
import RestaurantMainContent from "./containers/layout/RestaurantMainContent";
import RestaurantP24Merchants from "./containers/pages/restaurants/RestaurantP24Merchants";
import RestaurantP24Logs from "./containers/pages/restaurants/RestaurantP24Logs";

const App = () => {
  return (
    <Router history={history}>

      <ParentLayout>

        <Switch>
          <PublicRoute path={routes.LOGIN} layout={PublicLayout} component={Login} />
          <PublicRoute path={routes.FORGOT_PASSWORD} layout={PublicLayout} component={ForgotPassword} />
          <PublicRoute path={routes.RESET_PASSWORD} layout={PublicLayout} component={ResetPassword} />

          <PrivateRoute exact path={routes.HOME} layout={PrivateLayout} component={Home} />
          <PrivateRoute path={routes.USERS} layout={PrivateLayout} component={Users} />
          <PrivateRoute path={routes.NETWORKS} layout={PrivateLayout} component={Networks} />
          <PrivateRoute exact path={routes.RESTAURANTS} layout={PrivateLayout} component={Restaurants} />

          {/*Restaurant Submenu */}
          <PrivateRoute exact path={routes.RESTAURANT} layout={PrivateLayout} component={Restaurant} content={RestaurantMainContent} />
          <PrivateRoute path={routes.RESTAURANT_P24_MERCHANTS} layout={PrivateLayout} component={RestaurantP24Merchants} content={RestaurantMainContent}/>
          <PrivateRoute path={routes.RESTAURANT_P24_TRANSACTIONS} layout={PrivateLayout} component={RestaurantP24Transactions} content={RestaurantMainContent}/>
          <PrivateRoute path={routes.RESTAURANT_P24_LOGS} layout={PrivateLayout} component={RestaurantP24Logs} content={RestaurantMainContent}/>

          <PrivateRoute path={routes.CONNECTIONS} layout={PrivateLayout} component={Connections} />
          <PrivateRoute path={routes.SETTINGS} layout={PrivateLayout} component={Settings} />
          <PrivateRoute exact path={routes.P24_TRANSACTIONS} layout={PrivateLayout} component={P24Transactions} content={P24MainContent} />
          <PrivateRoute exact path={routes.P24_TRANSACTION} layout={PrivateLayout} component={P24Transaction} content={P24MainContent} />
          <PrivateRoute exact path={routes.P24_MERCHANTS} layout={PrivateLayout} component={P24Merchants} content={P24MainContent} />
          <PrivateRoute exact path={routes.P24_LOGS} layout={PrivateLayout} component={P24Logs} content={P24MainContent} />

          {/* obsluga wszystkich nieznalezionych stron - zawsze tu wpada jak nie znajdzie route wyzej*/}
          <PublicRoute layout={PublicLayout} component={NotFoundPage} />
        </Switch>

      </ParentLayout>

    </Router>
  );
};

export default App;
